import React from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import AddBusiness from "../../components/Business/AddBusiness";

export default function BusinessDashboard(props) {
  const user = props.user;

  const history = useHistory();

  const goToBusiness = () => {
    history.push(`/business/${user.Business.id}`);
  };
  return (
    <div className="col-6">
      <h2>Brand Dashboard</h2>
      {user.Business ? (
        <div>
          <h4>My business: {user.Business.name}</h4>
          <p>Status: {user.Business.status}</p>
          {user.Business && user.Business.status != "claimed" && (
            <p>
              <i>
                We will follow up with you via email to verify you own this
                business
              </i>
            </p>
          )}
          <Button onClick={goToBusiness}>View Public Page</Button>
        </div>
      ) : (
        <div>
          <AddBusiness fetchUser={props.fetchUser} jwt={props.jwt} />
        </div>
      )}
    </div>
  );
}
